import React from "react";
import translate from "../../../i18n/translate";
import "./MyScheduleSummaryBlock.scss";
import CloseIcon from '@material-ui/icons/Close';

const RescheduleFirstPage = (props: any) => {
    return (
        <div id="intercept-first-page">
          <CloseIcon className="close-button" fontSize="large" onClick={props.onClose} />
          <div className="jss1591 jss1580">
            <div className="jss1582">
              <div className="jss1581">
                <span>{translate("myschedule_reschedule_InstrBegin")}</span>
              </div>
              <div className="jss930">
                <div className="jss931 jss992">
                  <div className="jss1592">
                    <div>
                      <span className="jss1593">
                        <span className="jss1594">
                          <svg className="jss1598" focusable="false" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="11" fill="none" stroke="#19B29C" stroke-width="2"></circle>
                            <text className="jss1599" x="12" y="16" textAnchor="middle" stroke="#19B29C">
                              1
                            </text>
                          </svg>
                        </span>
                        <span className="jss1597">
                          <span className="jss1595">
                            <span>{translate("myschedule_reschedule_instr1a")}</span>
                          </span>
                        </span>
                      </span>
                      <div className="jss1596">
                        <span>{translate("myschedule_reschedule_instr1b")}</span>
                      </div>
                    </div>
                    <div>
                      <span className="jss1593">
                        <span className="jss1594">
                          <svg className="jss1598" focusable="false" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="11" fill="none" stroke="#19B29C" stroke-width="2"></circle>
                            <text className="jss1599" x="12" y="16" text-anchor="middle" stroke="#19B29C">
                              2
                            </text>
                          </svg>
                        </span>
                        <span className="jss1597">
                          <span className="jss1595">
                            <span>{translate("myschedule_reschedule_instr2")}</span>
                          </span>
                        </span>
                      </span>
                      <div className="jss1596">
                        <span>{translate("myschedule_reschedule_instr3")}</span>
                      </div>
                    </div>
                    <div>
                      <span className="jss1593">
                        <span className="jss1594">
                          <svg className="jss1598" focusable="false" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="11" fill="none" stroke="#19B29C" stroke-width="2"></circle>
                            <text className="jss1599" x="12" y="16" text-anchor="middle" stroke="#19B29C">
                              3
                            </text>
                          </svg>
                        </span>
                        <span className="jss1597">
                          <span className="jss1595">
                            <span>{translate("myschedule_reschedule_instr4")}</span>
                          </span>
                        </span>
                      </span>
                      <div className="jss1697">
                        <span>{translate("myschedule_reschedule_instr5")}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="jss931 jss992">
                  <div className="jss1583">
                    <img src="../../../images/Schedule/reschedule-session.png" alt="tms_session_reschedule" className="jss1584" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      
    );
  };

  export default RescheduleFirstPage;